import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface ServiceListReq {
  /** 终端设备id */
  device_id: string
  /** 是否已授权 true-已授权，false-未授权 */
  is_auth?: boolean
  /** 每页数量 */
  limit: number
  key_word?: string
  /** 当前页 */
  page: number
  /** 系统类型 */
  system_type?: number
}

export interface ServiceList {
  /** 价格id */
  price_id: string
  /** 权益服务key */
  permission_name: string
  /** 权益服务显示名称 */
  display_name: string
  /** 服务分类 */
  class_name: string
  /** 订阅剩余天数 */
  expire_day: number
  /** 到期日期 */
  expire_date: number
  /** 数据类型 ：true-免费 false-不免费 */
  is_free: boolean
}

export interface ServiceListRes {
  total: number,
  /** 订阅的服务集合 */
  data: ServiceList[]
}

@Injectable()
export class ServiceManageService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getServiceList (data: ServiceListReq) {
    return this.http.post<ServiceListRes>('/permission_service/device_auth_service', data)
  }
}
